import axios from 'axios';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import {
  subscribe,
  updatePodcastDataAfterFetch
} from '../../../redux/actions/app-actions';
import { default as config } from '../../../constants/constants';
import { firebase } from '../../../firebase';
import logo from '../../../images/inflo_logo.png';
import PodcastWithDocuments from './PodcastWithDocuments.js';
import { useEffect } from 'react';
import { fetchSubscribedPodcasts } from '../../../apis/podcasts';

const PodcastWithDocumentsWrapper = (props) => {
  const { podcast, podcasts, category, goBack } = props;

  useEffect(() => {
    if (!podcasts || podcasts.length === 0) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        fetchSubscribedPodcasts(token).then((res) => {
          props.updatePodcastDataAfterFetch(res);
        });
      });
    }
  }, []);

  const subscribe = () => {
    if (firebase.auth.currentUser) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        let elem = document.getElementById('un-sub');
        if (elem?.innerHTML == 'Subscribe') {
          const values = {
            name: podcast.name,
            podcastId: podcast.podcastId,
            imageUrl: podcast.imgUrl,
            feedUrl: props.feedUrl,
            artistName: podcast.artist,
            subscribed: true,
            webPodcast: true
          };
          props
            .subscribeToPodcast(values, token)
            .then((result) => {
              if (result?.error) {
                swal({
                  imageUrl: logo,
                  title: '<div class="titleModal">Subscription failed.</div>',
                  html:
                    '<p class="contentModal">Could not subscribe to the podcast at the moment.</p>',
                  showConfirmButton: false,
                  showCloseButton: true,
                  background: '#121C24',
                  allowOutsideClick: false
                });
              } else {
                const newSubscribedPodcast = result.payload.data;
                const updatedPodcastsPayload = {
                  data: [...podcasts, newSubscribedPodcast]
                };
                props.updatePodcastDataAfterFetch(updatedPodcastsPayload);

                swal({
                  imageUrl: logo,
                  title:
                    '<div class="titleModal">Successfully Subscribed to Podcast.</div>',
                  html: '<p class="contentModal"></p>',
                  showConfirmButton: true,
                  showCloseButton: true,
                  background: '#121C24',
                  allowOutsideClick: false
                });
                if (elem?.innerHTML == 'Subscribe')
                  elem.innerHTML = 'Unsubscribe';
              }
            })
            .catch((error) => {
              console.error('Subscription error:', error);
              swal({
                imageUrl: logo,
                title: '<div class="titleModal">Subscription failed.</div>',
                html:
                  '<p class="contentModal">Could not subscribe to the podcast at the moment.</p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            });
        } else {
          unsubscribe();
        }
      });
    }
  };

  const unsubscribe = () => {
    swal({
      imageUrl: logo,
      title: '<div class="titleModal">Unsubscribe from podcast.</div>',
      html: '<p class="contentModal">Are you sure you want to continue?</p>',
      showCancelButton: true,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#E31690'
    })
      .then((result) => {
        if (result) {
          if (firebase.auth.currentUser) {
            firebase.auth.currentUser.getIdToken().then((token) => {
              const options = {
                method: 'PUT',
                headers: { 'X-Firebase-Auth': token },
                url: `${config.serverURL}/podcasts?podcastId=${podcast.podcastId}`
              };
              axios(options)
                .then((res) => {
                  const updatedSubscribedPodcasts = podcasts.filter(
                    (subscribedPodcast) =>
                      podcast.podcastId !== subscribedPodcast.podcastId
                  );
                  const updatedPodcastsPayload = {
                    data: updatedSubscribedPodcasts
                  };
                  props.updatePodcastDataAfterFetch(updatedPodcastsPayload);
                  let elem = document.getElementById('un-sub');
                  if (elem?.innerHTML == 'Subscribe')
                    elem.innerHTML = 'Unsubscribe';
                  else elem.innerHTML = 'Subscribe';
                })
                .catch((err) => {
                  swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">Unsubscription failed.</div>',
                    html:
                      '<p class="contentModal">Could not unsubscribe from the podcast at the moment.</p>',
                    showConfirmButton: false,
                    showCloseButton: true,
                    background: '#121C24',
                    allowOutsideClick: false
                  });
                });
            });
          }
        }
      })
      .catch((error) => {});
  };

  return (
    <PodcastWithDocuments
      goBack={goBack}
      category={category?.category}
      name={podcast.name}
      podcastId={podcast.podcastId}
      imgUrl={podcast.imgUrl}
      feedUrl={props.feedUrl}
      artist={podcast.artist}
      summary={podcast.summary}
      onClick={subscribe}
      podcast={podcast}
    />
  );
};

const mapStateToProps = (state) => ({
  feedUrl: state.player.feedUrl,
  podcasts: state.app.podcasts
});

const mapDispatchToProps = (dispatch) => ({
  subscribeToPodcast: (value, token) => dispatch(subscribe(value, token)),
  updatePodcastDataAfterFetch: (podcasts) =>
    dispatch(updatePodcastDataAfterFetch(podcasts))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PodcastWithDocumentsWrapper);
